/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  CreateDocumentFolderRequest,
  CreateDocumentFolderRequestFromJSON,
  CreateDocumentFolderRequestToJSON,
  CreateDocumentFolderResponse,
  CreateDocumentFolderResponseFromJSON,
  CreateDocumentFolderResponseToJSON,
  DestroyDocumentFolderBadResponse,
  DestroyDocumentFolderBadResponseFromJSON,
  DestroyDocumentFolderBadResponseToJSON,
  DestroyDocumentFolderResponse,
  DestroyDocumentFolderResponseFromJSON,
  DestroyDocumentFolderResponseToJSON,
  GetDocumentFoldersResponse,
  GetDocumentFoldersResponseFromJSON,
  GetDocumentFoldersResponseToJSON,
  UpdateDocumentFolderRequest,
  UpdateDocumentFolderRequestFromJSON,
  UpdateDocumentFolderRequestToJSON,
  UpdateDocumentFolderResponse,
  UpdateDocumentFolderResponseFromJSON,
  UpdateDocumentFolderResponseToJSON
} from '../models'

export interface UserV1DocumentFoldersDocumentFolderIdDeleteRequest {
  documentFolderId: string
}

export interface UserV1DocumentFoldersDocumentFolderIdPutRequest {
  documentFolderId: string
  updateDocumentFolderRequest?: UpdateDocumentFolderRequest
}

export interface UserV1DocumentFoldersPostRequest {
  createDocumentFolderRequest?: CreateDocumentFolderRequest
}

/**
 *
 */
export class ApiUserV1DocumentFolderApi extends runtime.BaseAPI {
  /**
   * 資料フォルダを削除する
   * destroy
   */
  async userV1DocumentFoldersDocumentFolderIdDeleteRaw(
    requestParameters: UserV1DocumentFoldersDocumentFolderIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<DestroyDocumentFolderResponse>> {
    if (requestParameters.documentFolderId === null || requestParameters.documentFolderId === undefined) {
      throw new runtime.RequiredError(
        'documentFolderId',
        'Required parameter requestParameters.documentFolderId was null or undefined when calling userV1DocumentFoldersDocumentFolderIdDelete.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/document_folders/{document_folder_id}`.replace(
          `{${'document_folder_id'}}`,
          encodeURIComponent(String(requestParameters.documentFolderId))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => DestroyDocumentFolderResponseFromJSON(jsonValue))
  }

  /**
   * 資料フォルダを削除する
   * destroy
   */
  async userV1DocumentFoldersDocumentFolderIdDelete(
    requestParameters: UserV1DocumentFoldersDocumentFolderIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<DestroyDocumentFolderResponse> {
    const response = await this.userV1DocumentFoldersDocumentFolderIdDeleteRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * 資料フォルダを更新する
   * update
   */
  async userV1DocumentFoldersDocumentFolderIdPutRaw(
    requestParameters: UserV1DocumentFoldersDocumentFolderIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<UpdateDocumentFolderResponse>> {
    if (requestParameters.documentFolderId === null || requestParameters.documentFolderId === undefined) {
      throw new runtime.RequiredError(
        'documentFolderId',
        'Required parameter requestParameters.documentFolderId was null or undefined when calling userV1DocumentFoldersDocumentFolderIdPut.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/user/v1/document_folders/{document_folder_id}`.replace(
          `{${'document_folder_id'}}`,
          encodeURIComponent(String(requestParameters.documentFolderId))
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateDocumentFolderRequestToJSON(requestParameters.updateDocumentFolderRequest)
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => UpdateDocumentFolderResponseFromJSON(jsonValue))
  }

  /**
   * 資料フォルダを更新する
   * update
   */
  async userV1DocumentFoldersDocumentFolderIdPut(
    requestParameters: UserV1DocumentFoldersDocumentFolderIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<UpdateDocumentFolderResponse> {
    const response = await this.userV1DocumentFoldersDocumentFolderIdPutRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * 資料フォルダの一覧を取得する
   * index
   */
  async userV1DocumentFoldersGetRaw(
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<GetDocumentFoldersResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/user/v1/document_folders`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => GetDocumentFoldersResponseFromJSON(jsonValue))
  }

  /**
   * 資料フォルダの一覧を取得する
   * index
   */
  async userV1DocumentFoldersGet(
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<GetDocumentFoldersResponse> {
    const response = await this.userV1DocumentFoldersGetRaw(initOverrides)
    return await response.value()
  }

  /**
   * 資料フォルダを作成する
   * create
   */
  async userV1DocumentFoldersPostRaw(
    requestParameters: UserV1DocumentFoldersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<runtime.ApiResponse<CreateDocumentFolderResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/user/v1/document_folders`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateDocumentFolderRequestToJSON(requestParameters.createDocumentFolderRequest)
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, jsonValue => CreateDocumentFolderResponseFromJSON(jsonValue))
  }

  /**
   * 資料フォルダを作成する
   * create
   */
  async userV1DocumentFoldersPost(
    requestParameters: UserV1DocumentFoldersPostRequest = {},
    initOverrides?: RequestInit | runtime.InitOverideFunction
  ): Promise<CreateDocumentFolderResponse> {
    const response = await this.userV1DocumentFoldersPostRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
